import logo from "../dilution-logo.png";

export function Header() {
  return (
    <div className="block w-full items-center justify-start gap-4 px-6 py-4 shadow-sm">
      <img src={logo} alt="Dilution Logo" className="h-14" />
    </div>
  );
}
